import { render, staticRenderFns } from "./CompanyContactCard.vue?vue&type=template&id=147bb1a5&"
import script from "./CompanyContactCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyContactCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports